// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__TqC2J","colCheckbox":"styles_colCheckbox__26HEU"};